export enum EErrorType {
  NOT_AUTHENTICATED = 'User not authenticated',
  INVALID_QUERY = 'Invalid Query',
  UNKNOWN_ERROR = 'Unknown error',
  UNKNOWN_EXCEPTION = 'Unknown exception',
  UNKNOWN_FB_ERROR = 'Unknown Firebase error',
  DOCUMENT_NOT_FOUND = 'Firebase document is not found',
  NOT_FOUND = 'The document you are looking for does not exist',
  NOT_OWNER = 'Permission denied: You are not the owner',
  OFFLINE = 'Offline: No network connection available.',
  FAILED_ACTIVATE = 'Failed to activate entity.',
  FAILED_DEACTIVATE = 'Failed to deactivate entity.',
  FAILED_GENERATE_API = 'Failed to Generate API Key.',
  FAILED_DELETE = 'Failed to delete entity.',
  FAILED_UPDATE = 'Failed to update entity.',
  FAILED_CREATE = 'Failed to create entity.',
  FAILED_PUBLIC = 'Failed to toggle public entity.',
  FAILED_GET_ALL = 'Failed to get entities.',
  FAILED_GET = 'Failed to get entity.',
  FEATURE_IN_USE = 'Feature is assigned to a subscription attached to a tenant and cannot be deactivated.',
}

export enum EErrorStatus {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  SUCCESS = 'success',
}

export type TErrorData = {
  message: string;
  name: string;
} & Error;

export type TError = {
  data: TErrorData;
  description: string;
};
